<template>
    <div class="screen">
        <AcceptAgreementsDialog v-if="isLoggedIn" @confirm="onAgreementAccepted()" @cancel="onAgreementCanceled()"/>
        <main class="page-content">
            <router-view />
        </main>
        <Footer/>
        <errors-dialog/>
        <cr-announcer/>
    </div>
</template>

<style>
/* Global Styles */
.screen
{
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: var(--cr-background-gradient);
}
.page-content
{
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
}

/* Dialog - Title & buttons */
.cr-dialog-header-title
{
    text-align: center;
    flex-grow: 1;
}
.cr-error-dialog .cr-dialog-header-title
{
    text-align: left;
}
.cr-dialog-header > .cr-spacer,
.cr-dialog-footer > .cr-spacer
{
    flex-grow: 0;
}
.cr-dialog-footer
{
    justify-content: center !important;
}
.cr-dialog-footer .cr-button
{
    border-radius: var(--cr-pill-button-border-radius);
}

/* Dialog - Colors */
.modal-content
{
    background-color: var(--cr-dialog-background-color);
    color: var(--cr-text);
}
.modal-backdrop.show
{
    opacity: 0.9;
}

/* Link focus */
a:focus-visible
{
    outline: none;
    box-shadow: 0 0 0 0.15rem var(--cr-input-focus-box-shadow-color);
    border-radius: 4px;
}
.cr-card-link:focus-visible
{
    box-shadow: none;
}
.cr-card-link:focus-visible .level-card
{
    box-shadow: 0 0 0 0.15rem var(--cr-input-focus-box-shadow-color);
}
</style>

<script setup lang="ts">
import ErrorsDialog from './dialogs/ErrorsDialog.vue';
import AcceptAgreementsDialog from './dialogs/AcceptAgreementsDialog.vue';
import { useSessionStore } from '../stores/sessionStore';
import { useCompetitionStore } from '../stores/competitionStore';
import { useTeamStore } from '../stores/teamStore';
import { computed } from 'vue';
import Footer from './Footer.vue';

const isLoggedIn = computed(() => useSessionStore().isLoggedIn);

const onAgreementAccepted = async (): Promise<void> =>
{
    const teamId = useTeamStore().myTeamId || await useTeamStore().fetchMyTeamId();

    if (!teamId)
    {
        await useCompetitionStore().joinCompetition();
    }
};

const onAgreementCanceled = (): void =>
{
    useSessionStore().logout();
};
</script>

